export default __webpack_public_path__ + "static/project-banner-mobile-8b57192dc7c1820cdc04153d90d81b2f.jpg";